import { render, staticRenderFns } from "./vue-tab.vue?vue&type=template&id=4aad185c"
import script from "./vue-tab.vue?vue&type=script&lang=js"
export * from "./vue-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/josh/CODE/king-living/king-living-outlet-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aad185c')) {
      api.createRecord('4aad185c', component.options)
    } else {
      api.reload('4aad185c', component.options)
    }
    module.hot.accept("./vue-tab.vue?vue&type=template&id=4aad185c", function () {
      api.rerender('4aad185c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/vue-tab.vue"
export default component.exports